import { RG_TYPE, roundDecimals } from "@project-rouge/rg-core";
const ArrangeInARow = ({ row, rot, z, coreRot = 180, gap, offsetX = 0 }) => {
	let x = offsetX;
	for (const c of row) {
		c.pos[2] = roundDecimals(z);
		c.pos[0] = roundDecimals(x + c.size[0] * c.anchor[0]);
		x = roundDecimals(x + c.size[0] + gap);
		if (c.type === RG_TYPE.Apartment) c.rot[1] = rot;
		else if (c.type === RG_TYPE.Core) c.rot[1] = rot - coreRot;
	}
	return x - offsetX;
};
export { ArrangeInARow };

//# sourceMappingURL=index128.js.map